import React from 'react';
import '../App.css';


const Header = () => {
  return (
    <header className="header">
      <div className="header-content">
        <h1 className="header-title">Java Dev Assistant</h1>
        <img src="/4quality.png" alt="Logo 4Quality" className="logo-4quality" />

      </div>
    </header>
  );
};

export default Header;
